import { Stack, Typography, useTheme } from '@mui/material';
import { CreditCoinIcon } from 'src/components/Icons';
import { useGetPointsFeature } from 'src/hooks/useGetPointsFeature';
import {useLocation} from "react-router-dom";

interface ICreditCostIndicatorProps {
  pointData: ReturnType<typeof useGetPointsFeature>;
}

const CreditCostIndicator = (props: ICreditCostIndicatorProps) => {
  const location = useLocation();
  if(location.pathname.includes('public')) return <></>
  const { pointData } = props;
  const theme = useTheme();

  return pointData?.planName ? (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={0.5}
      py={0.5}
      px={1}
      borderRadius={theme.shape.borderRadius}
      bgcolor="rgba(255, 255, 255, 0.12)"
    >
      <Typography variant="caption2" component="span" color="white">
        {pointData?.creditCosts}
      </Typography>
      <CreditCoinIcon fontSize="small" />
    </Stack>
  ) : (
    <CreditCoinIcon fontSize="small" />
  );
};

export default CreditCostIndicator;
